import { render, staticRenderFns } from "./TabOrderList.vue?vue&type=template&id=7a788f7d&"
import script from "./TabOrderList.js?vue&type=script&lang=js&"
export * from "./TabOrderList.js?vue&type=script&lang=js&"
import style0 from "./TabOrderList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TabOrderList.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fuseraccount%2FTabOrderList%2FTabOrderList.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports